import ExerciseForm from '@/view/forms/exercise-form'
import GroupsForm from '@/view/forms/groups-form'
import { useCashfitParams } from '@/view/hooks/use-params'
import { BicepsFlexed, Dumbbell, PlusCircle } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayExercice } from './panels/display-exercise'
import { DisplayGroups } from './panels/display-groups'

type Tabs = 'muscle-groups' | 'register-group' | 'exercises' | 'register-excercise'

export default function ExercisePage() {
  const { getParam, setParams } = useCashfitParams<Tabs>({
    navId: '17',
    tabSelected: 'register-group'
  })

  const tab = getParam('tabSelected')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between ">
          <Tabs
            defaultValue={getParam('tabSelected') || 'muscle-groups'}
            className="w-[400px]"
            onValueChange={(value) => {
              setParams({
                tabSelected: value as keyof Tabs
              })
            }}
          >
            <TabsList>
              <TabsTrigger value="register-group" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle />
                Adicionar Grupo
              </TabsTrigger>
              <TabsTrigger value="muscle-groups" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <BicepsFlexed />
                Grupos Musculares
              </TabsTrigger>
              <TabsTrigger value="register-excercise" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle />
                Adicionar Exercício
              </TabsTrigger>
              <TabsTrigger value="exercises" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <Dumbbell />
                Exercícios
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab === 'muscle-groups' && (
            <>
              <header className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-acelerait-black text-2xl font-bold">Grupos Musculares</h3>
                  <p className="text-sm text-acelerafit-gray-dark">Gerencie e organize os grupos musculares disponíveis no sistema.</p>
                </div>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayGroups />
              </div>
            </>
          )}

          {tab == 'register-group' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar Grupo Muscular</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo grupo muscular no sistema.</p>
              </header>
              <GroupsForm />
            </>
          )}

          {tab === 'exercises' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Exercícios</h3>
                <p className="text-sm text-acelerafit-gray-dark">Visualize e gerencie todos os exercícios cadastrados.</p>
              </header>
              <DisplayExercice />
            </>
          )}

          {tab == 'register-excercise' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar Exercício</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo exercício no sistema.</p>
              </header>
              <ExerciseForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
